import { getInboxChatResources } from 'widget/api/inboxChatResources';
import { SET_INBOX_CHAT_RESOURCES } from '../types';

export const state = {
  records: [],
};

export const getters = {
  getResources(_state) {
    return _state.records;
  },
  getActiveResources(_state) {
    return _state.records.filter(resource => resource.active);
  },
};

export const actions = {
  async get({ commit }, websiteToken) {
    try {
      const response = await getInboxChatResources(websiteToken);
      commit(SET_INBOX_CHAT_RESOURCES, response.data);
    } catch (error) {
      commit(SET_INBOX_CHAT_RESOURCES, []);
    }
  },
};

export const mutations = {
  [SET_INBOX_CHAT_RESOURCES](_state, data) {
    _state.records = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
